import { useState } from 'react';
import LeafletMap from '../../../components/feature/LeafletMap';

const OFFICES = [
  {
    id: 'paris',
    city: 'Paris',
    country: 'France',
    flag: '🇫🇷',
    entity: 'ITEC Groupe',
    address: '14 rue Beffroy',
    postalCity: '92200 Neuilly-sur-Seine',
    region: 'France',
    icon: 'ri-building-4-line',
    // Position on the SVG map (percentage of width/height)
    x: 47.8,
    y: 33.5,
  },
  {
    id: 'lyon',
    city: 'Lyon',
    country: 'France',
    flag: '🇫🇷',
    entity: 'ITEC Groupe',
    address: 'Agence Lyon',
    postalCity: '',
    region: 'France',
    icon: 'ri-building-4-line',
    x: 48.5,
    y: 35.8,
  },
  {
    id: 'tunis',
    city: 'Tunis',
    country: 'Tunisie',
    flag: '🇹🇳',
    entity: 'ITEC Tunisie',
    address: 'Centre de services et ingénierie',
    postalCity: '',
    region: 'Tunisie',
    icon: 'ri-building-2-line',
    x: 50.5,
    y: 40.2,
  },
  {
    id: 'dubai',
    city: 'Dubai',
    country: 'UAE',
    flag: '🇦🇪',
    entity: 'ITEC Systems & Software Consulting - FZCO',
    address: 'Dubai UAE',
    postalCity: '',
    region: 'UAE',
    icon: 'ri-building-line',
    x: 60.5,
    y: 42.5,
  },
];

export default function ImplantationsSection() {
  const [activeOffice, setActiveOffice] = useState<string | null>(null);

  const selected = OFFICES.find((o) => o.id === activeOffice);
  void selected;

  return (
    <section className="py-24 lg:py-32 bg-brand-dark">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-widest text-[#14B8A6] uppercase mb-4">
            Présence mondiale
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-5">
            Nos implantations internationales
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed">
            ITEC Groupe est présent sur 3 continents avec des bureaux à Paris, Lyon, Tunis et Dubai pour accompagner ses clients au plus près de leurs enjeux.
          </p>
        </div>

        {/* Map + Cards layout */}
        <div className="bg-brand-dark-card rounded-3xl shadow-xl overflow-hidden border border-white/10">
          {/* Leaflet Map */}
          <LeafletMap className="h-[450px] md:h-[450px] w-full" />

          {/* Office Cards Row */}
          <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-white/10">
            {OFFICES.map((office, idx) => (
              <button
                key={office.id}
                onClick={() =>
                  setActiveOffice(activeOffice === office.id ? null : office.id)
                }
                className={`group text-left p-6 transition-all duration-300 cursor-pointer ${
                  idx < 3 ? 'border-r border-white/10' : ''
                } ${
                  activeOffice === office.id
                    ? 'bg-[#14B8A6]/10 border-t-2 border-t-[#14B8A6]'
                    : 'hover:bg-white/5 border-t-2 border-t-transparent'
                }`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-lg transition-all duration-300 ${
                      activeOffice === office.id
                        ? 'bg-[#14B8A6] text-white'
                        : 'bg-[#14B8A6]/10 text-[#14B8A6] group-hover:bg-[#14B8A6] group-hover:text-white'
                    }`}
                  >
                    <i className={`${office.icon} text-lg`}></i>
                  </div>
                  <span className="text-xl">{office.flag}</span>
                </div>
                <h4 className="font-bold text-white text-base mb-0.5">
                  {office.city}
                </h4>
                <p className="text-xs text-[#14B8A6] font-medium mb-2">{office.country}</p>
                <p className="text-xs text-gray-400 leading-relaxed line-clamp-2">
                  {office.entity}
                </p>
                {activeOffice === office.id && (
                  <div className="mt-3 pt-3 border-t border-white/10 space-y-0.5">
                    {office.address && (
                      <p className="text-xs text-gray-300">{office.address}</p>
                    )}
                    {office.postalCity && (
                      <p className="text-xs text-gray-300">{office.postalCity}</p>
                    )}
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-10 grid grid-cols-3 gap-6 text-center">
          {[
            { value: '4', label: 'Bureaux', icon: 'ri-building-4-line' },
            { value: '3', label: 'Continents', icon: 'ri-earth-line' },
            { value: '10+', label: 'Années d\'expérience', icon: 'ri-award-line' },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-brand-dark-card rounded-2xl p-6 border border-white/10 shadow-sm flex flex-col items-center gap-2"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#14B8A6]/10 rounded-lg">
                <i className={`${stat.icon} text-xl text-[#14B8A6]`}></i>
              </div>
              <span className="text-3xl font-bold text-white">{stat.value}</span>
              <span className="text-sm text-gray-400">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
